(function(){
  function inject(){
    var ul = document.querySelector('.header__primary-nav ul');
    if(ul && !document.querySelector('.header__primary-nav .cwr-ig')){
      var li = document.createElement('li');
      li.className = 'header__primary-nav-item cwr-ig';
      li.innerHTML = '<a href="https://www.instagram.com/coogee.wine.room/" target="_blank" rel="noopener" aria-label="Instagram"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="3" y="3" width="18" height="18" rx="5"></rect><circle cx="12" cy="12" r="4"></circle><circle cx="17.5" cy="6.5" r="1.1" fill="currentColor" stroke="none"></circle></svg></a>';
      ul.appendChild(li);
    }
    if(ul && !document.querySelector('.header__primary-nav .cwr-fb')){
      var fb = document.createElement('li');
      fb.className = 'header__primary-nav-item cwr-ig cwr-fb';
      fb.innerHTML = '<a href="https://www.facebook.com/coogeewineroom" target="_blank" rel="noopener" aria-label="Facebook"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M14 9h3V6h-3c-1.7 0-3 1.3-3 3v2H9v3h2v6h3v-6h2.5l.5-3H14V9z"></path></svg></a>';
      ul.appendChild(fb);
    }
    var sul = document.querySelector('.header__secondary-nav ul');
    if(sul && !document.querySelector('.cwr-ig-mobile')){
      var mli = document.createElement('li');
      mli.className = 'cwr-ig cwr-ig-mobile md:hidden';
      mli.innerHTML = '<a href="https://www.instagram.com/coogee.wine.room/" target="_blank" rel="noopener" aria-label="Instagram"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="3" y="3" width="18" height="18" rx="5"></rect><circle cx="12" cy="12" r="4"></circle><circle cx="17.5" cy="6.5" r="1.1" fill="currentColor" stroke="none"></circle></svg></a>';
      sul.appendChild(mli);
    }
  }
  function shareButtons(){
    var root=document.querySelector('.cwr .pad') || document.querySelector('.cwr');
    if(root && !document.querySelector('.cwr .share')){
      var d=document.createElement('div'); d.className='share';
      d.innerHTML='<span>Share</span>'
        +'<a class="sh-fb" target="_blank" rel="noopener" aria-label="Share on Facebook" href="#"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M14 9h3V6h-3c-1.7 0-3 1.3-3 3v2H9v3h2v6h3v-6h2.5l.5-3H14V9z"></path></svg></a>'
        +'<a class="sh-x" target="_blank" rel="noopener" aria-label="Share on X" href="#"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M18.9 2H22l-7.5 8.6L23 22h-6.8l-5.3-6.9L4.8 22H2l8-9.2L1.5 2h6.9l4.8 6.3L18.9 2z"></path></svg></a>'
        +'<a class="sh-em" aria-label="Share by email" href="#"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><rect x="3" y="5" width="18" height="14" rx="2"></rect><path d="M3 7l9 6 9-6"></path></svg></a>'
        +'<button class="sh-cp" type="button" aria-label="Copy link"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M10 13a5 5 0 0 0 7 0l2-2a5 5 0 0 0-7-7l-1 1"></path><path d="M14 11a5 5 0 0 0-7 0l-2 2a5 5 0 0 0 7 7l1-1"></path></svg></button>';
      root.appendChild(d);
    }
    var u=encodeURIComponent(location.origin+location.pathname), t=encodeURIComponent(document.title);
    var f=document.querySelector('.sh-fb'); if(f) f.href='https://www.facebook.com/sharer/sharer.php?u='+u;
    var x=document.querySelector('.sh-x'); if(x) x.href='https://twitter.com/intent/tweet?url='+u+'&text='+t;
    var em=document.querySelector('.sh-em'); if(em) em.href='mailto:?subject='+t+'&body='+u;
    var c=document.querySelector('.sh-cp'); if(c && !c.dataset.b){ c.dataset.b='1'; c.addEventListener('click',function(){ var ln=location.origin+location.pathname; if(navigator.clipboard) navigator.clipboard.writeText(ln); var s=c.innerHTML; c.textContent='✓'; setTimeout(function(){ c.innerHTML=s; },1400); }); }
  }
  function dropdownAlign(){
    if(window.innerWidth < 1000) return;
    document.querySelectorAll('.header__primary-nav .header__dropdown-menu').forEach(function(dd){
      var item=dd.closest('.header__primary-nav-item'); if(!item) return;
      var trig=item.querySelector('summary, a'); if(!trig) return;
      dd.style.setProperty('padding-left', Math.round(trig.getBoundingClientRect().left)+'px', 'important');
    });
  }
  function gallery(){
    if(!window.CWR_GALLERY) return;
    var imgs=document.querySelectorAll('.cwr .gallery img');
    if(!imgs.length) return;
    window.CWR_GALLERY.forEach(function(u,i){ if(u && imgs[i]){ imgs[i].removeAttribute('srcset'); imgs[i].src=u; } });
  }
  function featured(){
    if(!window.CWR_FEATURED) return;
    var cards=document.querySelectorAll('.cwr .sig-grid .sig-card');
    if(!cards.length) return;
    window.CWR_FEATURED.forEach(function(d,i){
      var c=cards[i]; if(!c||!d) return;
      if(d.img){ var im=c.querySelector('img'); if(im){ im.removeAttribute('srcset'); im.src=d.img; if(d.name) im.alt=d.name; } }
      var badge=c.querySelector('.badge'); if(badge){ if(d.badge){ badge.textContent=d.badge; badge.style.display=''; } else { badge.style.display='none'; } }
      var name=c.querySelector('.sig-name'); if(name && d.name){ name.textContent=d.name; }
      var desc=c.querySelector('.sig-desc'); if(desc && d.desc){ desc.textContent=d.desc; }
      var price=c.querySelector('.sig-price'); if(price && d.price){ price.textContent=d.price; }
    });
  }
  function contactBanner(){
    var b=window.CWR_BANNER; if(!b || !b.img) return;
    if(document.querySelector('.cwr-banner')) return;
    var ph=document.querySelector('main .shopify-section--image-with-text-overlay');
    if(!ph) return;                       // only act where the theme has a banner slot
    var main=document.querySelector('main'); if(!main) return;
    var el=document.createElement('section'); el.className='cwr-banner';
    var bg=document.createElement('div'); bg.className='cwr-banner__bg'; if(b.img){ bg.style.backgroundImage='url("'+b.img+'")'; }
    var ov=document.createElement('div'); ov.className='cwr-banner__ov';
    var inner=document.createElement('div'); inner.className='cwr-banner__in';
    var hh=document.createElement('h1'); hh.textContent=b.h||''; inner.appendChild(hh);
    if(b.s){ var pp=document.createElement('p'); pp.textContent=b.s; inner.appendChild(pp); }
    el.appendChild(bg); el.appendChild(ov); el.appendChild(inner);
    if(ph){ ph.style.display='none'; ph.parentNode.insertBefore(el, ph); } else { main.insertBefore(el, main.firstChild); }
    var mp=document.querySelector('main .shopify-section--main-page h1'); if(mp){ mp.style.cssText='position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;margin:-1px;padding:0;border:0;'; }
  }
  function faqAccordion(){
    if(document.querySelector('.cwr details.cwr-acc')) return;
    [].slice.call(document.querySelectorAll('.cwr h2')).filter(function(h){ return /frequently asked questions/i.test(h.textContent); }).forEach(function(h){
      var pairs=[], remove=[], n=h.nextElementSibling;
      while(n && n.tagName!=='H2'){
        if(n.tagName==='H3'){
          var a=n.nextElementSibling;
          if(a && a.tagName==='P'){ pairs.push({q:n.textContent, a:a.innerHTML}); remove.push(n); remove.push(a); n=a.nextElementSibling; continue; }
        }
        n=n.nextElementSibling;
      }
      if(!pairs.length) return;
      h.classList.add('cwr-faqh');
      var wrap=document.createElement('div'); wrap.className='cwr-faqwrap';
      pairs.forEach(function(p){
        var d=document.createElement('details'); d.className='cwr-acc';
        var sm=document.createElement('summary'); sm.textContent=p.q;
        var bd=document.createElement('div'); bd.className='cwr-acc-body'; bd.innerHTML=p.a;
        d.appendChild(sm); d.appendChild(bd); wrap.appendChild(d);
      });
      remove.forEach(function(el){ el.remove(); });
      h.parentNode.insertBefore(wrap, h.nextSibling);
    });
  }
  function dietLabels(){
    var map={gf:'Gluten Free',df:'Dairy Free',v:'Vegetarian',vg:'Vegan'};
    document.querySelectorAll('.cwr .diet button[data-d]').forEach(function(b){ if(map[b.dataset.d]) b.textContent=map[b.dataset.d]; });
  }
  function contactBand(){
    if(document.querySelector('.cwr-visit')) return;
    var footer=document.querySelector('.footer'); if(!footer) return;
    var sec=document.createElement('section'); sec.className='cwr-visit';
    sec.innerHTML='<div class="cwr-visit__grid">'
      +'<div><h3>Contact</h3><p><a href="tel:+61296655478">(02) 9665 5478</a></p><p><a href="mailto:enquiries@coogeewineroom.com.au">enquiries@coogeewineroom.com.au</a></p><p>222 Coogee Bay Road,<br>Coogee NSW 2034</p></div>'
      +'<div><iframe loading="lazy" title="Map to Coogee Wine Room, 222 Coogee Bay Road" src="https://maps.google.com/maps?q=222%20Coogee%20Bay%20Road%2C%20Coogee%20NSW%202034&t=&z=15&ie=UTF8&iwloc=&output=embed"></iframe></div>'
      +'<div><h3>Hours</h3><p>Mon–Fri: 4.00pm – Late</p><p class="em">Open Mondays from 2 November.</p><p>Sat: 12.00pm – Late</p><p>Sun: 1.00pm – 9.00pm</p><p class="em">Additional hours available for private functions.</p></div>'
      +'</div>';
    footer.parentNode.insertBefore(sec, footer);
  }
  function footerText(){
    // Rename "Footer menu" heading -> EXPLORE
    var bl=document.querySelector('.footer__block--links');
    if(bl){ var w=document.createTreeWalker(bl,NodeFilter.SHOW_TEXT,null,false),n; while(n=w.nextNode()){ if(/Footer menu/i.test(n.nodeValue)){ n.nodeValue=n.nodeValue.replace(/Footer menu/i,'EXPLORE'); } } }
    // "Powered by Shopify" -> "Website by Cultivate Studio"
    var aside=document.querySelector('.footer__aside');
    if(aside && !aside.querySelector('.cwr-credit')){
      var link=aside.querySelector('a[href*="shopify.com"]');
      if(link){ link.outerHTML='<br>Website by <a class="cwr-credit" href="https://www.cultivatestudio.com.au" target="_blank" rel="noopener">Cultivate Studio</a>'; }
      else { var w2=document.createTreeWalker(aside,NodeFilter.SHOW_TEXT,null,false),m,tgt=null; while(m=w2.nextNode()){ if(/Powered by Shopify/i.test(m.nodeValue)) tgt=m; } if(tgt){ var sp=document.createElement('span'); sp.innerHTML='<br>Website by <a class="cwr-credit" href="https://www.cultivatestudio.com.au" target="_blank" rel="noopener">Cultivate Studio</a>'; tgt.parentNode.replaceChild(sp,tgt); } }
    }
  }
  function functionsEnquiry(){
    if(location.pathname.indexOf('/pages/functions')<0) return;
    var pad=document.querySelector('.cwr .pad'); if(!pad) return;
    pad.querySelectorAll('a').forEach(function(a){ if(/enquire now/i.test(a.textContent||'')){ a.setAttribute('href','#cwr-enquire'); } });
    if(document.querySelector('[data-qz]')) return;
    var wrap=document.createElement('div');
    wrap.innerHTML='<h2 id="cwr-enquire">Make an Enquiry</h2><div class="qz" data-qz><div class="qz-prog"><div class="qz-bar"></div></div><div class="qz-stage"></div></div>';
    var anchor=pad.querySelector('.enquiry');
    if(anchor){ pad.insertBefore(wrap, anchor); } else { pad.appendChild(wrap); }
    var stage=wrap.querySelector('.qz-stage'), bar=wrap.querySelector('.qz-bar');
    var Q=[
      {key:'eventType',q:'What kind of event are you planning?',type:'choice',required:true,choices:['Corporate Event','Personal Event']},
      {key:'guests',q:'Approximately how many guests will be attending?',type:'number',required:true,placeholder:'e.g. 30'},
      {key:'style',q:'A stand-up cocktail-style event, or a sit-down meal?',type:'choice',required:true,choices:['Standing','Seated','Unsure']},
      {key:'av',q:'Do you need any multimedia for the event?',type:'yesno',required:true,help:'Projector, screen or microphone'},
      {key:'date',q:'Do you have a date in mind?',type:'date',required:false},
      {key:'time',q:'What time are you hoping to commence?',type:'text',required:false,placeholder:'e.g. 6:30pm'},
      {key:'notes',q:'Anything else we should know to tailor a package for you?',type:'longtext',required:false,placeholder:'Optional'},
      {key:'contact',q:'Please confirm your details so we can get in touch.',type:'contact',required:true},
      {key:'name',q:'And lastly, your name!',type:'text',required:true,placeholder:'Your name'}
    ];
    var A={}, i=0;
    function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
    function setBar(){ bar.style.width=Math.round((i/Q.length)*100)+'%'; }
    function err(m){ var e=stage.querySelector('.qz-err'); if(e){ e.textContent=m; } }
    function render(){
      setBar(); var q=Q[i];
      var h='<div class="qz-step">'+(i+1)+' / '+Q.length+'</div><div class="qz-q">'+q.q+'</div>';
      if(q.help){ h+='<div class="qz-help">'+q.help+'</div>'; }
      if(q.type==='choice'||q.type==='yesno'){
        var opts=q.type==='yesno'?['Yes','No']:q.choices;
        h+='<div class="qz-opts">';
        opts.forEach(function(o){ h+='<button type="button" class="qz-opt'+(A[q.key]===o?' sel':'')+'" data-val="'+esc(o)+'">'+esc(o)+'</button>'; });
        h+='</div>';
      } else if(q.type==='longtext'){
        h+='<textarea data-input placeholder="'+esc(q.placeholder)+'">'+esc(A[q.key])+'</textarea>';
      } else if(q.type==='contact'){
        var c=A.contact||{};
        h+='<div class="qz-row"><span class="qz-lab">Email</span><input type="email" data-input data-k="email" value="'+esc(c.email)+'" placeholder="you@email.com"></div>';
        h+='<div class="qz-row"><span class="qz-lab">Phone</span><input type="tel" data-k="phone" value="'+esc(c.phone)+'" placeholder="04xx xxx xxx"></div>';
      } else {
        var t=q.type==='date'?'date':(q.type==='number'?'number':'text');
        h+='<input type="'+t+'" data-input value="'+esc(A[q.key])+'" placeholder="'+esc(q.placeholder)+'">';
      }
      h+='<div class="qz-err"></div><div class="qz-nav">';
      if(i>0){ h+='<button type="button" class="qz-back">Back</button>'; }
      if(q.type!=='choice'&&q.type!=='yesno'){ h+='<button type="button" class="qz-next">'+(i===Q.length-1?'Review':'OK')+'</button>'; }
      h+='</div>';
      stage.innerHTML=h;
      var inp=stage.querySelector('[data-input]'); if(inp){ inp.focus(); }
      stage.querySelectorAll('.qz-opt').forEach(function(b){ b.addEventListener('click',function(){ A[q.key]=b.getAttribute('data-val'); adv(); }); });
      var nx=stage.querySelector('.qz-next'); if(nx){ nx.addEventListener('click',step); }
      var bk=stage.querySelector('.qz-back'); if(bk){ bk.addEventListener('click',function(){ i--; render(); }); }
      stage.querySelectorAll('input').forEach(function(el){ el.addEventListener('keydown',function(e){ if(e.key==='Enter'){ e.preventDefault(); step(); } }); });
    }
    function step(){
      var q=Q[i];
      if(q.type==='contact'){
        var em=(stage.querySelector('[data-k="email"]').value||'').trim(), ph=(stage.querySelector('[data-k="phone"]').value||'').trim();
        if(!em||em.indexOf('@')<1){ err('Please enter a valid email.'); return; }
        A.contact={email:em,phone:ph};
      } else if(q.type!=='choice'&&q.type!=='yesno'){
        var v=(stage.querySelector('[data-input]').value||'').trim();
        if(q.required&&!v){ err('This field is required.'); return; }
        A[q.key]=v;
      }
      adv();
    }
    function adv(){ if(i<Q.length-1){ i++; render(); } else { finish(); } }
    function finish(){
      bar.style.width='100%';
      var lines=Q.map(function(q){ var v=A[q.key]; if(q.type==='contact'){ var c=A.contact||{}; v=c.email+(c.phone?(' / '+c.phone):''); } return q.q+'\n'+(v||'-'); }).join('\n\n');
      var subject='Function Enquiry'+(A.name?(' - '+A.name):'');
      var mailto='mailto:enquiries@coogeewineroom.com.au?subject='+encodeURIComponent(subject)+'&body='+encodeURIComponent(lines);
      stage.innerHTML='<div class="qz-done"><div class="qz-q">All done, thanks!</div><div class="qz-help">Tap send below and your enquiry opens in an email to our team. We will be in touch shortly.</div><div class="qz-nav" style="justify-content:center"><a class="qz-next" style="text-decoration:none" href="'+mailto+'">Send enquiry</a> <button type="button" class="qz-back" data-restart>Start over</button></div></div>';
      var rs=stage.querySelector('[data-restart]'); if(rs){ rs.addEventListener('click',function(){ A={}; i=0; render(); }); }
    }
    render();
  }
  function backToTop(){
    if(document.querySelector('.cwr-top')) return;
    var b=document.createElement('button'); b.type='button'; b.className='cwr-top'; b.setAttribute('aria-label','Back to top'); b.innerHTML='↑';
    document.body.appendChild(b);
    var chk=function(){ if(window.scrollY>400) b.classList.add('show'); else b.classList.remove('show'); };
    window.addEventListener('scroll',chk,{passive:true}); chk();
    b.addEventListener('click',function(){ window.scrollTo({top:0,behavior:'smooth'}); });
  }
  function run(){ inject(); footerText(); contactBand(); dietLabels(); dropdownAlign(); faqAccordion(); gallery(); contactBanner(); functionsEnquiry(); featured(); backToTop(); }
  run();
  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
  window.addEventListener('resize', dropdownAlign);
  var n=0, t=setInterval(function(){ run(); if((document.querySelector('.header__primary-nav .cwr-ig')&&document.querySelector('.cwr-ig-mobile'))||++n>20) clearInterval(t); }, 250);
})();
